import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { formatSplitKey } from "../../../../commons/FormatValue";
import SearchFilter from "../../../../components/SearchFilter";
import Table from "../../../../components/Table";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import ParentBomsService from "../../../../services/parentboms.service";
import ChildBomsService from "../../../../services/childboms.service";
import SubBomsService from "../../../../services/subboms.service";

export default function DeleteBOMInformation() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [data, setData] = useState({ Parent: [], Child: [], SubBoms: [] });
  const searchInput = {
    Bom: [
      { name: "Item.Item_Code", label: "รหัสสินค้า" },
      { name: "Item.Item_Name_TH", label: "ชื่อสินค้า", size: 4 },
      { name: "Bom_Type", label: "ชนิด BOM", size: 2, noneAsync: true }
    ],
    SubBom: [
      { name: "Item.Item_Code", label: "รหัสอุปกรณ์/อะไหล่" },
      { name: "Item.Item_Name_TH", label: "ชื่ออุปกรณ์/อะไหล่", size: 6 }
    ]
  };
  const columns = {
    Bom: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รหัสอะไหล่/อุปกรณ์",
        selector: (row) => row.Item.Item_Code,
        sortable: true,
        grow: 1.5
      },
      {
        name: "ชื่ออะไหล่",
        selector: (row) => row.Item.Item_Name_TH,
        grow: 2.5
      },
      { name: "Model Number", selector: (row) => row.Item.Item_Model },
      { name: "จำนวน", selector: (row) => row.Item_Child_Qty, center: true },
      { name: "หน่วยนับ", selector: (row) => row.Item.Unit, center: true },
      {
        name: "เช็ค/เปลี่ยน",
        selector: (row) => (row.Bom_Pm ? "Y" : "N"),
        center: true
      },
      {
        name: "SUB BOM",
        selector: (row) => (row.Sub_Bom ? "Y" : "N"),
        center: true
      },
      {
        name: "",
        selector: (row) => (
          <ButtonOptionSubmenu
            data={row}
            deleteButton
            onDeleteCallback={handleSubmitChildBoms}
          />
        ),
        right: true,
        width: "125px"
      }
    ],
    SubBom: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รหัสลูกค้า",
        selector: (row) => row.Customer?.Cus_Code,
        sortable: true,
        grow: 1.5
      },
      {
        name: "ชื่อลูกค้า",
        selector: (row) => row.Customer?.Cus_Name,
        grow: 2
      },
      {
        name: "รหัสอะไหล่/อุปกรณ์",
        selector: (row) => row.Item?.Item_Code,
        sortable: true,
        grow: 1.5
      },
      {
        name: "ชื่ออะไหล่",
        selector: (row) => row.Item?.Item_Name_TH,
        grow: 2
      },
      {
        name: "Model Number",
        selector: (row) => row.Item?.Item_Model,
        grow: 1.5
      },
      { name: "จำนวน", selector: (row) => row.Item_Child_Sub_Qty },
      { name: "หน่วยนับ", selector: (row) => row.Item?.Unit },
      {
        name: "",
        selector: (row) => (
          <ButtonOptionSubmenu
            data={row}
            deleteButton
            onDeleteCallback={handleSubmitSubBoms}
          />
        ),
        right: true,
        width: "125px"
      }
    ]
  };

  const getAllParentBoms = () => {
    setLoading(true);
    ParentBomsService.getAllParentBoms()
      .then((response) => setData((prev) => ({ ...prev, Parent: response })))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const getAllChildBoms = () => {
    setLoading(true);
    ChildBomsService.getAllChildBoms()
      .then((response) => setData((prev) => ({ ...prev, Child: response })))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const getAllSubBoms = () => {
    setLoading(true);
    SubBomsService.getAllSubBoms()
      .then((response) => setData((prev) => ({ ...prev, SubBoms: response })))
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  };

  const handleSearchFilter = (searchFilter) => {
    const arrData = state.type === "Bom" ? data.Parent : data.Child;
    const key = state.type === "Bom" ? "Parent_Bom_Id" : "Child_Bom_Id";

    const filteredData = arrData
      .filter((data) =>
        searchFilter.every(
          ({ name, value }) =>
            !value || formatSplitKey(name, ".", data) === value
        )
      )
      .map(({ Id }) => ({ name: key, value: Id }));

    setSearchValue(filteredData.length <= 1 ? filteredData : []);
  };

  const handleSubmitChildBoms = (event, { Id }) => {
    event.preventDefault();

    if (Id) {
      setLoading(true);
      ChildBomsService.deleteChildBoms(Id, false)
        .then((_) => {
          showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
          getAllChildBoms();
        })
        .catch(({ error, message }) =>
          showAlert({ error, message, type: "danger" })
        )
        .finally(() => setLoading(false));
    }
  };

  const handleSubmitSubBoms = (event, { Id }) => {
    event.preventDefault();

    if (Id) {
      setLoading(true);
      SubBomsService.deleteSubBoms(Id, false)
        .then((_) => {
          showAlert({ error: "ดำเนินการสำเร็จ", type: "success" });
          getAllSubBoms();
        })
        .catch(({ error, message }) =>
          showAlert({ error, message, type: "danger" })
        )
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    getAllParentBoms();
    getAllChildBoms();
    if (state.type === "SubBom") getAllSubBoms();
  }, []);

  return (
    <>
      <Helmet>
        <title>{`ลบข้อมูล ${state.type === "Bom" ? "" : "SUB "}BOM`}</title>
        <meta
          name="description"
          content={`Delete ${
            state.type === "Bom" ? "" : "SUB "
          }BOM Information Page`}
        />
      </Helmet>

      <Container fluid className="p-3">
        <>
          <Card className="m-1 mb-4 p-4 border-0">
            <Card.Body>
              <SearchFilter
                data={state.type === "Bom" ? data.Parent : data.Child}
                inputField={searchInput[state.type]}
                fieldClassName={{ actionButton: "w-auto py-2" }}
                searchCallback={(searchCB) =>
                  searchCB.some(({ value }) => value)
                    ? handleSearchFilter(searchCB)
                    : []
                }
              />
            </Card.Body>
          </Card>

          <Card className="m-1 mb-4 p-4 border-0">
            <Card.Header className="p-3 bg-transparent border-bottom-0">
              <Card.Title className="mb-0 fs-2">
                รายละเอียด {state.type === "Bom" ? "" : "SUB "}BOM
              </Card.Title>
            </Card.Header>

            <Card.Body>
              <Table
                data={state.type === "Bom" ? data.Child : data.SubBoms}
                column={columns[state.type]}
                searchFilter={searchValue}
                pending={loading}
              />
            </Card.Body>

            <Card.Footer
              as={Row}
              className="bg-transparent border-top-0 justify-content-end"
            >
              <Col sm={2} className="w-auto p-3">
                <Button
                  type="submit"
                  variant="outline-secondary"
                  className="me-2 px-5 py-2 text-dark rounded-pill"
                  onClick={() =>
                    navigate("/wo_master/BOM", { state: state.type })
                  }
                >
                  ย้อนกลับ
                </Button>
              </Col>
            </Card.Footer>
          </Card>
        </>
      </Container>
    </>
  );
}
